import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-agreements-nyse-fine-print',
  templateUrl: 'agreements-nyse-fine-print.component.html',
  styleUrls: ['agreements-fine-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgreementsNyseFinePrintComponent  {
  namespace: string = 'tdWb.platform.preferences.agreements.fineprints';
}
